import React from "react";
import getFontSize from "../utils/getFontSize";

export default function renderText(text: string | undefined, minFontSize: number, maxFontSize: number, minTextLength: number, maxTextLength: number, className?: string) {
    if (!text || !text.length)
        return;

    return (
        <div className={className} style={{ fontSize: getFontSize(text!.length, minFontSize, maxFontSize, minTextLength, maxTextLength) }}>
            {text}
        </div>
    );
}